import apiClient from '../client';

class UserService {
    
    updateClientPreference = (data,token)=> apiClient().post('/client/update',data,{headers:{
        'x-access-token':token
    }});

    registerUser = (postData) => apiClient().post('/client/create', postData);
    
    verifyEmail = (registrationCode,email) => apiClient().post(`/client/verify-email/${email}`, {
        "registrationCode":registrationCode
    });

    signIn = (postData) => apiClient().post('/client/client-login', postData);

    forgotPassword = (postData) => apiClient().post(`/client/forgot-password/${postData}`, {});

    verifyOtp = (otp,email,token) => apiClient().post(`/client/verify-otp/${email}`,{
        "otp":otp
    }, {
        headers: {
            'x-access-token': token
        }});
    
    resendOtp = (email,token) => apiClient().post(`/client/resend-otp/${email}`,{}, {
        headers: {
            'x-access-token': token
        }});

    resendEmail = (email) => apiClient().post(`/client/resendCode/${email}`,{});

    verifyReset = (email,otp) => apiClient().post(`/client/verify-reset/${email}`,{otp:otp});

    loginUser = (postData) => apiClient().post('/client/login', postData);

    updatePassword = (data) => apiClient().post(`/client/password-update/${data.email}`, {"password":data.password}, {
        headers: {
            'x-access-token': data.token
        }
    });
    createNewUser = (data, token) => apiClient().post('/client/create', data, {
        headers: {
            'x-access-token': token
        }
    });
    getAllUsers = (token) => apiClient().post('/client/all', {}, {
        headers: {
            'x-access-token': token
        }
    });
    deleteUser = (token, user) => apiClient().post('/client/delete', user, {
        headers: {
            'x-access-token': token
        }
    });

    updateUser = (token, user) => apiClient().post('/client/update', user, {
        headers: {
            'x-access-token': token
        }
    });
}

export default new UserService();